<template>
  <v-card-text class="inserted-values px-9 pt-3">
    <v-row>
      <v-col cols="12" class="request-label v-card__title pb-0 pl-3">
        <h4>Specifikace technické změny</h4>
      </v-col>
      <v-col
        cols="12"
        v-if="individualConnectionAgreementHv.changeType === 'INCREASE_OF_RESERVED_POWER'"
        class="pt-2 black--text request-value"
      >
        Zvýšení rezervovaného příkonu
      </v-col>
      <v-col
        cols="12"
        v-if="individualConnectionAgreementHv.changeType === 'DECREASE_OF_RESERVED_POWER'"
        class="pt-2 black--text request-value"
      >
        Snížení rezervovaného příkonu
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="auto" md="4">
        <div class="request-label">
          Požadovaný rezervovaný příkon
        </div>
        <div class="pt-2 black--text request-value">
          {{ individualConnectionAgreementHv.requestedReservedPower }} kW
        </div>
      </v-col>
      <v-col cols="auto" md="4">
        <div class="request-label">
          Číslo TS
        </div>
        <div class="pt-2 black--text request-value">
          {{ individualConnectionAgreementHv.supplyPointDetails.distributionSubstation
          || missingValueString }}
        </div>
      </v-col>
      <v-col cols="auto" md="4">
        <div class="request-label">
          Požadovaný termín změny
        </div>
        <div class="pt-2 black--text request-value">
          {{ dateFormatting(individualConnectionAgreementHv.requiredDateOfChange)
          || missingValueString }}
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="request-label v-card__title pb-0 pl-3">
        <h4>Kontaktní informace žadatele</h4>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="auto" md="2">
        <div class="request-label">
          Jméno
        </div>
        <div class="pt-2 black--text request-value">
          {{ individualConnectionAgreementHv.contactDetails.name }}
        </div>
      </v-col>
      <v-col cols="auto" md="2">
        <div class="request-label">
          Příjmení
        </div>
        <div class="pt-2 black--text request-value">
          {{ individualConnectionAgreementHv.contactDetails.surname }}
        </div>
      </v-col>
      <v-col cols="auto" md="3">
        <div class="request-label">
          Telefon
        </div>
        <div class="pt-2 black--text request-value">
          {{ formatPhoneNumber(individualConnectionAgreementHv.contactDetails.phone) }}
        </div>
      </v-col>
      <v-col cols="auto">
        <div class="request-label">
          E-mail
        </div>
        <div class="pt-2 black--text request-value">
          {{ individualConnectionAgreementHv.contactDetails.email }}
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="auto" md="2">
        <div class="request-label">
          Město
        </div>
        <div class="pt-2 black--text request-value">
          {{ individualConnectionAgreementHv.contactDetails.city }}
        </div>
      </v-col>
      <v-col cols="auto" md="2">
        <div class="request-label">
          Ulice
        </div>
        <div class="pt-2 black--text request-value">
          {{ individualConnectionAgreementHv.contactDetails.street }}
        </div>
      </v-col>
      <v-col cols="auto" md="2">
        <div class="request-label">
          Číslo popisné
        </div>
        <div class="pt-2 black--text request-value">
          {{ individualConnectionAgreementHv.contactDetails.houseNumber }}
        </div>
      </v-col>
      <v-col cols="auto" md="2">
        <div class="request-label">
          Číslo orientačné
        </div>
        <div class="pt-2 black--text request-value">
          {{ individualConnectionAgreementHv.contactDetails.landRegistryNumber }}
        </div>
      </v-col>
      <v-col cols="auto">
        <div class="request-label">
          PSČ
        </div>
        <div class="pt-2 black--text request-value">
          {{ individualConnectionAgreementHv.contactDetails.postCode }}
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="request-label v-card__title pb-0 pl-3">
        <h4>Zástoupený</h4>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="auto" md="2">
        <div class="request-label">
          Jméno
        </div>
        <div class="pt-2 black--text request-value">
          {{ individualConnectionAgreementHv.contactDetails.substituteName }}
        </div>
      </v-col>
      <v-col cols="auto" md="2">
        <div class="request-label">
          Příjmení
        </div>
        <div class="pt-2 black--text request-value">
          {{ individualConnectionAgreementHv.contactDetails.substituteSurname }}
        </div>
      </v-col>
      <v-col cols="auto" md="2">
        <div class="request-label">
          Funkce
        </div>
        <div class="pt-2 black--text request-value">
          {{ individualConnectionAgreementHv.contactDetails.substituteFunction }}
        </div>
      </v-col>
      <v-col cols="auto">
        <div class="request-label">
          Plná moc
        </div>
        <div class="pt-2 black--text request-value">
          <a
            :href="
              checkExistenceObjectWithUrl(
                individualConnectionAgreementHv.contactDetails.contactSubstitutePowerOfAttorney
              )
            "
            @click.prevent="
              downloadAttachment(
                $event,
                individualConnectionAgreementHv.contactDetails.contactSubstitutePowerOfAttorney
              )
            "
          >
            {{
              checkExistenceObjectWithName(individualConnectionAgreementHv.contactDetails) ||
                missingValueString
            }}
          </a>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="request-label v-card__title pb-0 pl-3">
        <h4>Požadavek na zvýšenou spolehlivost dodávky</h4>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div class="pt-2 black--text request-value">
          {{
            individualConnectionAgreementHv.supplyReliability === 'STANDARD'
              ? 'Standardní'
              : 'Nadstandardní'
          }}
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="request-label v-card__title pb-0 pl-3">
        <h4>Kompenzace transformátoru</h4>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div class="pt-2 black--text request-value">
          {{ individualConnectionAgreementHv.powerFactor ? 'Ano' : 'Není' }}
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="request-label v-card__title pb-0 pl-3">
        <h4>Instalované transformátory</h4>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="auto" md="3">
        <div class="request-label">
          Měrění na straně
        </div>
        <div class="pt-2 black--text request-value">
          {{
            individualConnectionAgreementHv.transformersDetails.measurement === 'PRIMARY'
              ? 'Primární'
              : 'Sekundární'
          }}
        </div>
      </v-col>
      <v-col cols="auto" md="2">
        <div class="request-label">
          Počet
        </div>
        <div class="pt-2 black--text request-value">
          {{ individualConnectionAgreementHv.transformersDetails.quantity || missingValueString }}
        </div>
      </v-col>
      <v-col cols="auto" md="4">
        <div class="request-label">
          Celkový instalovaný výkon v transformaci
        </div>
        <div class="pt-2 black--text request-value">
          {{
            individualConnectionAgreementHv.transformersDetails.installedPower || missingValueString
          }}
          kVA
        </div>
      </v-col>
      <v-col cols="auto">
        <div class="request-label">
          Napětí
        </div>
        <div class="pt-2 black--text request-value">
          {{ individualConnectionAgreementHv.transformersDetails.voltage || missingValueString }} kV
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="auto" md="5">
        <div class="request-label">
          Měsíční hodnota jalových ztrát v pásmu 1 hodiny
        </div>
        <div class="pt-2 black--text request-value">
          {{
            individualConnectionAgreementHv.transformersDetails.reactiveLosses || missingValueString
          }}
          kVArh
        </div>
      </v-col>
      <v-col>
        <div class="request-label">
          Sdílení výkonu transformátoru
        </div>
        <div class="pt-2 black--text request-value">
          {{ individualConnectionAgreementHv.transformersDetails.sharing ? 'Ano' : 'Není' }}
        </div>
      </v-col>
    </v-row>

    <div v-if="individualConnectionAgreementHv.alternativeSource">
      <v-row>
        <v-col cols="12" class="request-label v-card__title pb-0 pl-3">
          <h4>Náhradní zdroj - technické parametry</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <div class="request-label">
            Druh náhradního zdroje
          </div>
          <div class="pt-2 black--text request-value">
            {{ individualConnectionAgreementHv.alternativeSourceDetails.kind }}
          </div>
        </v-col>
        <v-col>
          <div class="request-label">
            Typ
          </div>
          <div class="pt-2 black--text request-value">
            {{
              individualConnectionAgreementHv.alternativeSourceDetails.type || missingValueString
            }}
          </div>
        </v-col>
        <v-col>
          <div class="request-label">
            Výrobce
          </div>
          <div class="pt-2 black--text request-value">
            {{
              individualConnectionAgreementHv.alternativeSourceDetails.producer ||
                missingValueString
            }}
          </div>
        </v-col>
        <v-col>
          <div class="request-label">¨ Druh generátoru</div>
          <div class="pt-2 black--text request-value">
            {{
              individualConnectionAgreementHv.alternativeSourceDetails.generatorType ||
                missingValueString
            }}
          </div>
        </v-col>
        <v-col>
          <div class="request-label">
            Počet stejných zařízení
          </div>
          <div class="pt-2 black--text request-value">
            {{
              individualConnectionAgreementHv.alternativeSourceDetails.identicalDevices ||
                missingValueString
            }}
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" class="request-label v-card__title pb-0 pl-3">
          <h4>Data jednoho zařízení</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <div class="request-label">
            Činný výkon
          </div>
          <div class="pt-2 black--text request-value">
            {{ individualConnectionAgreementHv.alternativeSourceDetails.activePower }} kW
          </div>
        </v-col>
        <v-col>
          <div class="request-label">
            Zdánlivý výkon
          </div>
          <div class="pt-2 black--text request-value">
            {{
              individualConnectionAgreementHv.alternativeSourceDetails.apparentPerformance ||
                missingValueString
            }}
            kVA
          </div>
        </v-col>
        <v-col>
          <div class="request-label">
            Jmenovité napětí
          </div>
          <div class="pt-2 black--text request-value">
            {{
              individualConnectionAgreementHv.alternativeSourceDetails.ratedVoltage ||
                missingValueString
            }}
            V
          </div>
        </v-col>
        <v-col>
          <div class="request-label">
            Proud
          </div>
          <div class="pt-2 black--text request-value">
            {{
              individualConnectionAgreementHv.alternativeSourceDetails.electricity ||
                missingValueString
            }}
            A
          </div>
        </v-col>
        <v-col>
          <div class="request-label">
            Přechodná reaktance generátoru
          </div>
          <div class="pt-2 black--text request-value">
            {{
              individualConnectionAgreementHv.alternativeSourceDetails
                .transientGeneratorReactance || missingValueString
            }}
            Ω
          </div>
        </v-col>
        <v-col>
          <div class="request-label">
            Rázová reaktance generátoru
          </div>
          <div class="pt-2 black--text request-value">
            {{
              individualConnectionAgreementHv.alternativeSourceDetails.generatorSurgeReactance ||
                missingValueString
            }}
            Ω
          </div>
        </v-col>
      </v-row>
    </div>

    <v-row>
      <v-col cols="12" class="request-label v-card__title pb-0 pl-3">
        <h4>Údaje o odběrném místě (nově požadované)</h4>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div class="request-label">
          Využití prostorů
        </div>
        <div class="pt-2 black--text request-value">
          {{ individualConnectionAgreementHv.supplyPointDetails.useOfSpace || missingValueString }}
        </div>
      </v-col>
      <v-col cols="auto" md="3">
        <div class="request-label">
          Velikost prostorů
        </div>
        <div class="pt-2 black--text request-value">
          {{
            individualConnectionAgreementHv.supplyPointDetails.spaceSize || missingValueString
          }}
          m²
        </div>
      </v-col>
      <v-col cols="auto" md="3">
        <div class="request-label">
          el. top. PV AKU TČ
        </div>
        <div class="pt-2 black--text request-value">
          {{
            individualConnectionAgreementHv.supplyPointDetails.electricHeating || missingValueString
          }}
          kW
        </div>
      </v-col>
      <v-col cols="auto" md="3">
        <div class="request-label">
          klimatizace
        </div>
        <div class="pt-2 black--text request-value">
          {{
            individualConnectionAgreementHv.supplyPointDetails.airConditioning || missingValueString
          }}
          kW
        </div>
      </v-col>
      <v-col cols="auto" md="3">
        <div class="request-label">
          motory
        </div>
        <div class="pt-2 black--text request-value">
          {{ individualConnectionAgreementHv.supplyPointDetails.engines || missingValueString }} kW
        </div>
      </v-col>
      <v-col cols="auto" md="3">
        <div class="request-label">
          Ohřev vody AKU/PV
        </div>
        <div class="pt-2 black--text request-value">
          {{
            individualConnectionAgreementHv.supplyPointDetails.waterHeating || missingValueString
          }}
          kW
        </div>
      </v-col>
      <v-col cols="auto" md="3">
        <div class="request-label">
          elektromobilita
        </div>
        <div class="pt-2 black--text request-value">
          {{
            individualConnectionAgreementHv.supplyPointDetails.electromobility || missingValueString
          }}
          kW
        </div>
      </v-col>
      <v-col cols="auto" md="3">
        <div class="request-label">
          ostatní
        </div>
        <div class="pt-2 black--text request-value">
          {{ individualConnectionAgreementHv.supplyPointDetails.other || missingValueString }} kW
        </div>
      </v-col>
      <v-col cols="auto" md="3">
        <div class="request-label">
          bateriové úložiště - výkon
        </div>
        <div class="pt-2 black--text request-value">
          {{
            individualConnectionAgreementHv.supplyPointDetails.batteryStoragePerformance ||
              missingValueString
          }}
          kW
        </div>
      </v-col>
      <v-col cols="auto">
        <div class="request-label">
          bateriové úložiště - kapacita
        </div>
        <div class="pt-2 black--text request-value">
          {{
            individualConnectionAgreementHv.supplyPointDetails.batteryStorageCapacity ||
              missingValueString
          }}
          kWh
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div class="request-label">
          Celkem
        </div>
        <div class="pt-2 black--text request-value">
          {{ individualConnectionAgreementHv.supplyPointDetails.total }} kWh
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="request-label v-card__title pb-0 pl-3">
        <h4>Poznámka</h4>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div class="pt-2 black--text request-value">
          {{ individualConnectionAgreementHv.note || missingValueString }}
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="request-label v-card__title pb-0 pl-3">
        <h4>Příloha</h4>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div class="pt-2 request-value">
          <a
            :href="checkExistenceObjectWithUrl(individualConnectionAgreementHv.attachment)"
            @click.prevent="downloadAttachment($event, individualConnectionAgreementHv.attachment)"
          >
            {{
              checkExistenceObjectWithName(individualConnectionAgreementHv.attachment) ||
                missingValueString
            }}
          </a>
        </div>
      </v-col>
    </v-row>
  </v-card-text>
</template>

<script>
import { downloadFile } from '@/components/mixins/downloadFile';
import { formatPhoneNumber } from '@/components/mixins/formatPhoneNumber';

export default {
  name: 'RequestVNInsertedValues',
  mixins: [downloadFile, formatPhoneNumber],
  props: {
    individualConnectionAgreementHv: {
      type: Object,
      required: false,
    },
  },
  methods: {
    downloadAttachment($event, object) {
      if (object) {
        // prevent access url on undefined
        this.downloadFile($event, object.url);
      }
    },
    checkExistenceObjectWithUrl(object) {
      return object?.url;
    },
    checkExistenceObjectWithName(object) {
      return object?.name;
    },
  },
};
</script>
